import React from "react";
import SignatureGroup from "./SignatureGroup";
import { Box, Divider } from "@mui/material";
import {
  DealDocumentSignature,
  DealLegalEntity,
} from "../../../../api/generated-api";
import SignatureStatus from "./SignatureStatus";
import { useParams } from "react-router-dom";
import { DealRouteProps } from "../../../../routes/dealsRouting/DealsRoutes";

type CompanySignatureGroupProps = {
  isUserCompanyMember: boolean;
  title: string;
  dealLegalEntitiesForGroup: DealLegalEntity[];
  dealDocumentSignatures: DealDocumentSignature[];
  onOpenSignatureRequestPanel: (dealLegalEntityId: number) => void;
};

const CompanySignatureGroup = ({
  isUserCompanyMember,
  title,
  dealLegalEntitiesForGroup,
  dealDocumentSignatures,
  onOpenSignatureRequestPanel,
}: CompanySignatureGroupProps) => {
  const { orgId, dealId } = useParams<DealRouteProps>();

  if (!dealLegalEntitiesForGroup) {
    return null;
  }

  return (
    <SignatureGroup
      title={title}
      rightComponent={
        <Box display={"flex"} flexDirection={"column"} flex={1}>
          {dealLegalEntitiesForGroup.map((dealLegalEntity) => {
            return (
              <>
                <SignatureStatus
                  key={dealLegalEntity.id}
                  orgId={+orgId}
                  dealId={+dealId}
                  isUserCompanyMember={isUserCompanyMember}
                  dealLegalEntity={dealLegalEntity}
                  dealDocumentSignatures={dealDocumentSignatures.filter(
                    (dealDocumentSignature) =>
                      dealDocumentSignature.dealLegalEntityId ===
                      dealLegalEntity.id
                  )}
                  isSelected={false}
                  onOpenSignatureRequestPanel={() => {
                    onOpenSignatureRequestPanel(dealLegalEntity.id);
                  }}
                />
                <Box mb={5}>
                  <Divider />
                </Box>
              </>
            );
          })}
        </Box>
      }
    />
  );
};

export default CompanySignatureGroup;
